<template>
<div class="ShortMessage">
</div>
</template>

<script>
export default {
    name: 'ShortMessage',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.ShortMessage {
}
</style>
